
import type { LearningContentItem } from '@services/firebase/learning'
import {
  getYoutubeEmbedUrl,
  getYoutubeThumbnailUrl as getSharedYoutubeThumbnailUrl,
} from '@shared/media/youtube/youtube-embed-url'

export function getLegacyNumericField(
  source: LearningContentItem,
  fieldNames: readonly string[],
) {
  const record = source as unknown as Record<string, unknown>

  for (const fieldName of fieldNames) {
    const value = record[fieldName]

    if (typeof value === 'number' && Number.isFinite(value)) {
      return value
    }

    if (typeof value === 'string') {
      const numericValue = Number(value)

      if (Number.isFinite(numericValue)) {
        return numericValue
      }
    }
  }

  return undefined
}

export function getYoutubeThumbnailUrl(youtubeId: string) {
  return getSharedYoutubeThumbnailUrl(youtubeId)
}
export function getLegacyYoutubeEmbedUrl(youtubeId: string, startAt: number) {
  return getYoutubeEmbedUrl(youtubeId, {
    controls: false,
    enableJsApi: true,
    fullscreen: false,
    start: startAt,
  })
}

export function parseYoutubeMessage(data: unknown) {
  let payload = data

  if (typeof payload === 'string') {
    try {
      payload = JSON.parse(payload) as unknown
    } catch {
      return null
    }
  }

  if (!payload || typeof payload !== 'object') {
    return null
  }

  return payload as {
    readonly event?: string
    readonly info?: {
      readonly currentTime?: number
      readonly duration?: number
      readonly playerState?: number
    }
  }
}
